import React from "react"
import { BsX } from "react-icons/bs"
import { useTranslation } from "react-i18next"
import * as Components from "../../../components/components"
import Zahlungsbedingung from "../../../models/zahlungsbedingung"

interface ZahlungsbedingungKomplexEintragViewProps {
    typ: "SKONTO" | "VERZUG"
    bedingung: Zahlungsbedingung
    onChange: (propertyName: string) => (value: any) => void
    onRemove: () => void
}

export function ZahlungsbedingungKomplexEintragView({ bedingung, typ, onChange, onRemove }: ZahlungsbedingungKomplexEintragViewProps) {
    const { t } = useTranslation()
    return bedingung && typ === bedingung.typ ? (
        <Components.Row>
            <Components.Col size={3} sizeSmallDown={12}>
                <Components.FormGroup label={t("rechnung.zahlungsdaten.zahlungsbedingungen.tage.label")} inline={true} labelClassName="required">
                    <Components.NumberEdit
                        placeholder={t("rechnung.zahlungsdaten.zahlungsbedingungen.tage.placeholder")}
                        onChange={onChange("tage")}
                        value={bedingung.tage}
                        suffix=""
                        decimalScale={0}
                    />
                </Components.FormGroup>
            </Components.Col>
            <Components.Col size={3} sizeSmallDown={12}>
                <Components.FormGroup label={t("rechnung.zahlungsdaten.zahlungsbedingungen.prozent.label")} inline={true} labelClassName="required">
                    <Components.NumberEdit
                        placeholder={t("rechnung.zahlungsdaten.zahlungsbedingungen.prozent.placeholder")}
                        onChange={onChange("prozent")}
                        value={bedingung.prozent}
                        suffix=" %"
                    />
                </Components.FormGroup>
            </Components.Col>
            <Components.Col size={5} sizeSmallDown={12}>
                <Components.FormGroup label={t("rechnung.zahlungsdaten.zahlungsbedingungen.basisbetrag.label")} inline={true}>
                    <Components.NumberEdit
                        placeholder={t("rechnung.zahlungsdaten.zahlungsbedingungen.basisbetrag.placeholder")}
                        onChange={onChange("basisbetrag")}
                        value={bedingung.basisbetrag}
                    />
                </Components.FormGroup>
            </Components.Col>
            <Components.Col size={1} sizeSmallDown={12} align={Components.Align.RIGHT}>
                <div style={{ marginTop: "calc(1.5em + .75rem + 2px)" }}>
                    <button
                        className="btn btn-outline-secondary"
                        type="button"
                        onClick={onRemove}
                        title={t("rechnung.zahlungsdaten.zahlungsbedingungen.loeschen")}
                    >
                        <BsX />
                    </button>
                </div>
            </Components.Col>
        </Components.Row>
    ) : null
}
